import { DateTime } from 'luxon';
import React, { useState } from 'react';

import Buscando from 'Component/Admin/Buscando';
import SemRegistros from 'Component/Admin/SemRegistros';
import Icone from 'Component/Icone';
import { useRecuperarAvaliacoesRespondidasQuery } from 'Service';

interface Props {
  usuarioId: number;
  cursoId: number;
}

const Avaliacoes = ({ usuarioId, cursoId }: Props): React.ReactElement => {
  const [aberto, setAberto] = useState<number>(0);

  const { data: { avaliacoes_respondidas } = {}, isLoading } =
    useRecuperarAvaliacoesRespondidasQuery({
      contain: ['Modulos', 'Respostas'],
      options: {
        usuario_id: usuarioId,
        curso_id: cursoId,
      },
      scope: false,
    });

  return (
    <React.Fragment>
      <Buscando exibir={isLoading} />
      <SemRegistros
        carregando={isLoading}
        registros={avaliacoes_respondidas?.length}
      />
      {avaliacoes_respondidas?.map((avaliacao, indice) => (
        <div
          key={`${avaliacao.id}-${avaliacao.modificado}`}
          className={`${indice ? 'border-top' : ' mt-n3'} p-3 mx-n3`}
        >
          <div
            className="d-flex justify-content-between align-items-center cursor-pointer"
            onClick={() => setAberto(indice)}
          >
            <h4 className="mb-0">
              {avaliacao.modulo?.nome}
              {avaliacao.status == 1 ? (
                <span className="badge text-bg-success fs-6 ms-2">
                  Aprovado
                </span>
              ) : (
                <span className="badge text-bg-danger fs-6 ms-2">
                  Reprovado
                </span>
              )}
              <br />
              <small className="text-muted fs-6">
                Realizada em{' '}
                {avaliacao.criado
                  .data()
                  .toLocaleString(DateTime.DATETIME_SHORT)}
              </small>
            </h4>
            {aberto == indice ? (
              <Icone nome="chevron-down fs-3" />
            ) : (
              <Icone nome="chevron-up fs-3" />
            )}
          </div>
          {aberto == indice && (
            <div className="bg-light mx-n3 p-3">
              {avaliacao.respostas?.map((resposta, num) => (
                <div
                  key={`${resposta.id}-${resposta.modificado}`}
                  className={num ? 'border-top pt-3' : ''}
                >
                  <p>
                    <strong>#{num + 1}</strong> - {resposta.questao}
                  </p>
                  <p>
                    <strong>Resposta selecionada</strong>
                    <br />
                    <span
                      className={
                        resposta.correta ? 'text-danger' : 'text-success'
                      }
                    >
                      {resposta.alternativa}
                    </span>
                  </p>
                  {resposta.correta && (
                    <p>
                      <strong>Resposta correta</strong>
                      <br />
                      {resposta.correta}
                    </p>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </React.Fragment>
  );
};

export default Avaliacoes;
